import React from "react";
import thinkingReact from '../../assets/thinking-react.png';

const ThinkingReact = () => (
  <section id="thinking-react">
    <h1>"Penser" React</h1>
    <h4>Visualiser le découpage des composants</h4>
    <br />
    <br />
    <img style={{height: "auto", width: "auto"}} src={thinkingReact} alt="thinking React" />
  </section>
);

export default ThinkingReact;
